<template>
  <section class="page-section" v-loading="pageLoading">
    <!-- 步骤条 -->
    <div class="steps-bar flex-h">
      <div
        :class="[
          step == 1 ? 'steps-item flex-a-i active' : 'steps-item flex-a-i',
        ]"
      >
        step1：编辑基本信息
      </div>
      <div
        :class="[
          step == 2 ? 'steps-item flex-a-i active' : 'steps-item flex-a-i',
        ]"
      >
        step2：编辑商品/项目详情
      </div>
    </div>

    <!-- step 1 -->
    <div class="step-content" v-show="step == 1">
      <el-form
        size="small"
        ref="formData"
        :model="formData"
        label-width="150px"
        class="content-form"
      >
        <!-- 基本信息 -->
        <div class="form-module">
          <div class="module-header">基本信息</div>
          <div class="module-body">
            <el-form-item required :show-message="false">
              <el-radio-group v-model="formData.baseInfo.abroadType">
                <el-radio :label="1">大贸</el-radio>
                <el-radio :label="2">跨境</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="创建类型" required :show-message="false">
              <el-radio-group
                :value="formData.baseInfo.pointType"
                @input="switchType"
              >
                <el-radio :label="0">商品</el-radio>
                <el-radio :label="2">权益</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="券码有效天数"
              required
              :show-message="false"
              v-show="formData.baseInfo.pointType == 2"
            >
              <el-input
                v-model="formData.baseInfo.day"
                class="w150"
                maxlength="5"
                placeholder="请输入正整数"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="权益类型"
              required
              :show-message="false"
              v-show="formData.baseInfo.pointType == 2"
            >
              <el-select
                v-model="formData.baseInfo.sonType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sonTypeData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <template v-if="formData.baseInfo.type === 0">
              <el-form-item label="产地" :show-message="false">
                <el-select
                  v-model="formData.baseInfo.regionId"
                  :loading="regionOptionsLoading"
                  placeholder=""
                  class="w150"
                >
                  <el-option
                    v-for="item in regionOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="'' + item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="进口税税率" :show-message="false">
                <el-select
                  v-model="formData.baseInfo.rateId"
                  :loading="rateOptionsLoading"
                  placeholder=""
                  class="w150"
                >
                  <el-option
                    v-for="item in rateOptions"
                    :key="item.id"
                    :label="item.rateLabel"
                    :value="'' + item.id"
                  ></el-option>
                </el-select>
                <el-checkbox
                  v-model="formData.baseInfo.includeTax"
                  true-label="1"
                  false-label="0"
                  class="margin-left-5"
                  >价格已含税</el-checkbox
                >
              </el-form-item>
              <el-form-item label="发货仓库" :show-message="false">
                <el-select
                  v-model="formData.baseInfo.warehouseId"
                  :loading="warehouseOptionsLoading"
                  placeholder=""
                  class="w300"
                >
                  <el-option
                    v-for="item in warehouseOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="'' + item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品货号" :show-message="false">
                <el-input
                  v-model="formData.baseInfo.code"
                  :disabled="formData.baseInfo.pointType == 2"
                  class="w150"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item
              :label="formData.baseInfo.type === 0 ? '商品名称' : '项目名称'"
              required
              :show-message="false"
            >
              <el-input
                v-model="formData.baseInfo.name"
                class="w400"
                maxlength="100"
                placeholder="中/英文字符、符号，不超过100个中文字符"
                @blur="handleValidGoodsName"
              ></el-input>
            </el-form-item>
            <el-form-item label="主图视频" :show-message="false" v-if="false">
              <div class="pics-box">
                <template v-if="uploadVideoList.length === 0">
                  <el-upload
                    :action="uploadPicUrl"
                    list-type="picture-card"
                    :file-list="uploadVideoList"
                    accept=".mp4,.mov"
                    drag
                    :on-preview="handleVideosPreview"
                    :on-remove="handleVideosRemove"
                    :on-success="handleVideosSuccess"
                    :on-error="handleVideosError"
                    :before-upload="handleVideosBeforeUpload"
                    :on-exceed="handleVideosExceed"
                    :limit="videosLimit"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </template>
                <template v-else>
                  <div class="video-box">
                    <div
                      v-for="(row, rowIndex) in uploadVideoList"
                      class="video-item"
                      :key="rowIndex"
                    >
                      <video
                        :src="row.response.data.path"
                        class="video"
                      ></video>
                      <div class="mask">
                        <i
                          class="el-icon-zoom-in"
                          @click.stop="handleVideosPreview"
                        ></i>
                        <i
                          class="el-icon-delete"
                          @click.stop="handleVideosRemove"
                        ></i>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <p class="tips">
                支持MP4、MOV格式，分辨率不低于720P，时长不超过30秒，大小不超过500MB。
              </p>
              <p class="tips">
                视频高宽比为1：1，建议尺寸：800*800像素，最多上传1个。
              </p>
            </el-form-item>
            <el-form-item
              :label="formData.baseInfo.type === 0 ? '商品图片' : '项目图片'"
              required
              :show-message="false"
            >
              <div class="pics-box pics-box-goods">
                <el-upload
                  :action="uploadPicUrl"
                  list-type="picture-card"
                  :file-list="uploadPicList"
                  accept=".png,.jpg,.jpeg"
                  drag
                  :on-preview="handlePicturesPreview"
                  :on-remove="handlePicturesRemove"
                  :on-success="handlePicturesSuccess"
                  :on-error="handlePicturesError"
                  :before-upload="handlePicturesBeforeUpload"
                  :on-exceed="handlePicturesExceed"
                  :limit="picsLimit"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <p class="tips">
                建议尺寸：800*800像素，可以拖拽图片调整顺序，最多上传6张
              </p>
            </el-form-item>
            <template v-if="formData.baseInfo.type === 0">
              <el-form-item label="商品规格" required :show-message="false">
                <div
                  class="delete-block w465"
                  v-for="(item, index) in formData.baseInfo.specification.list"
                  :key="index"
                >
                  <div
                    class="icon-delete"
                    @click="handleSpecificationDelete(index)"
                  ></div>

                  <div class="block-item">
                    <span class="label margin-right-10">规格名</span>
                    <el-select
                      v-model="item.name"
                      placeholder=""
                      class="w120"
                      @change="handleSpecificationChange(index)"
                    >
                      <el-option
                        v-for="nameItem in specificationNameOptions"
                        :key="nameItem.name"
                        :label="nameItem.name"
                        :value="nameItem.name"
                      ></el-option>
                    </el-select>
                    <el-checkbox
                      v-model="specificationPicsUploadVisible"
                      class="margin-left-20"
                      v-if="index == 0"
                      >添加规格图片</el-checkbox
                    >
                  </div>
                  <div class="block-item flex-h" v-if="item.name">
                    <div class="label margin-right-10">规格值</div>
                    <div class="flex-a-i clearfix">
                      <div
                        class="specification-value-item"
                        v-for="(valuesItem, valuesIndex) in item.valueNameList"
                        :key="valuesIndex"
                      >
                        <div class="input-delete-wrap">
                          <el-select
                            allow-create
                            filterable
                            v-model="valuesItem.name"
                            placeholder=""
                            class="w120"
                            @change="
                              handleSpecificationValuesSelectChange(
                                index,
                                valuesIndex,
                              )
                            "
                          >
                            <el-option
                              v-for="(vItem, vIndex) in valuesItem.valueOptions"
                              :key="vIndex"
                              :label="vItem.name"
                              :value="vItem.name"
                            ></el-option>
                          </el-select>
                          <div
                            class="btn-delete"
                            @click="
                              handleSpecificationValuesDelete(
                                index,
                                valuesIndex,
                              )
                            "
                            v-if="!valuesItem.loading"
                          ></div>
                          <el-button
                            type="primary"
                            size="small"
                            class="select-loading"
                            :loading="valuesItem.loading"
                            v-if="valuesItem.loading"
                          ></el-button>
                        </div>
                        <div
                          class="specification-pics-box"
                          v-if="index == 0 && specificationPicsUploadVisible"
                        >
                          <div class="pics-box">
                            <el-upload
                              :action="uploadPicUrl"
                              list-type="picture-card"
                              :data="{ index: valuesIndex }"
                              :file-list="valuesItem.picList"
                              accept=".png,.jpg,.jpeg"
                              drag
                              :on-preview="handleSpecificationPicturesPreview"
                              :on-remove="handleSpecificationPicturesRemove"
                              :on-success="handleSpecificationPicturesSuccess"
                              :on-error="handleSpecificationPicturesError"
                              :before-upload="
                                handleSpecificationPicturesBeforeUpload
                              "
                              :on-exceed="handleSpecificationPicturesExceed"
                              :limit="specificationPicsLimit"
                            >
                              <i class="el-icon-plus"></i>
                            </el-upload>
                          </div>
                        </div>
                      </div>
                      <el-button
                        type="text"
                        size="small"
                        @click="handleSpecificationValuesAdd(index)"
                        >添加规格值</el-button
                      >
                    </div>
                  </div>
                  <div
                    class="tips"
                    v-if="index == 0 && specificationPicsUploadVisible"
                  >
                    仅支持为第一组规格设置规格图片，买家选择不同规格会看到对应规格图片，建议尺寸：800
                    x 800像素
                  </div>
                </div>

                <el-button
                  type="default"
                  size="small"
                  plain
                  @click="handleSpecificationAdd"
                  :disabled="formData.baseInfo.specification.list.length > 2"
                  >添加规格</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="formData.baseInfo.specification.showSortButton"
                  @click="handleSpecificationDialogShow"
                  >自定义排序</el-button
                >
                <p class="tips">如：颜色、尺码等多种规格</p>
              </el-form-item>
              <el-form-item
                label="规格明细"
                v-if="formData.baseInfo.specification.particularData.length > 0"
                required
                :show-message="false"
              >
                <div class="grey-inline-block">
                  <el-table
                    size="small"
                    :data="formData.baseInfo.specification.particularData"
                    style="width: 100%"
                    class="paticular-table"
                    :span-method="handleParticularTableRowMethod"
                  >
                    <el-table-column
                      :label="formData.baseInfo.specification.list[0].name"
                      v-if="
                        formData.baseInfo.specification.list[0] &&
                        formData.baseInfo.specification.list[0].name &&
                        formData.baseInfo.specification.list[0].valueNameList
                          .length > 0
                      "
                    >
                      <template slot-scope="scope">
                        <p>{{ scope.row.firstValue }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="formData.baseInfo.specification.list[1].name"
                      v-if="
                        formData.baseInfo.specification.list[1] &&
                        formData.baseInfo.specification.list[1].name &&
                        formData.baseInfo.specification.list[1].valueNameList
                          .length > 0
                      "
                    >
                      <template slot-scope="scope">
                        <p>{{ scope.row.secondValue }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="formData.baseInfo.specification.list[2].name"
                      v-if="
                        formData.baseInfo.specification.list[2] &&
                        formData.baseInfo.specification.list[2].name &&
                        formData.baseInfo.specification.list[2].valueNameList
                          .length > 0
                      "
                    >
                      <template slot-scope="scope">
                        <p>{{ scope.row.thirdValue }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="* 价格(元)" width="80px">
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="scope.row.price"
                          @change="handleSetBaseInfoPrice"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="* 库存" width="80px">
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="scope.row.stock"
                          @change="handleSetBaseInfoStock"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="* 规格编码" width="80px">
                      <template slot-scope="scope">
                        <el-input
                          :disabled="formData.baseInfo.pointType == 2"
                          v-model="scope.row.skuCode"
                          @change="updateLocalParticularData"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="成本价" width="80px">
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="scope.row.cost"
                          @change="updateLocalParticularData"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="预设销量" width="80px">
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="scope.row.presetSale"
                          @change="handleSetBaseInfoPresetSale"
                        ></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="particular-toolbar">
                    <span class="text">批量设置</span>
                    <el-button
                      type="text"
                      size="small"
                      v-if="
                        !particularTools.priceInputShow &&
                        !particularTools.stockInputShow
                      "
                      @click="handleParticularSetPrice"
                      >价格</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      v-if="
                        !particularTools.stockInputShow &&
                        !particularTools.priceInputShow
                      "
                      @click="handleParticularSetStock"
                      >库存</el-button
                    >
                    <!-- price -->
                    <el-input
                      type="number"
                      size="small"
                      v-model="particularTools.price"
                      v-if="particularTools.priceInputShow"
                      class="w70 margin-left-10"
                    ></el-input>
                    <el-button
                      type="text"
                      size="small"
                      v-if="particularTools.priceInputShow"
                      @click="handleParticularSetPriceSubmit"
                      >保存</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      v-if="particularTools.priceInputShow"
                      @click="handleParticularSetPriceCancel"
                      >取消</el-button
                    >
                    <!-- stock -->
                    <el-input
                      type="number"
                      size="small"
                      v-model="particularTools.stock"
                      v-if="particularTools.stockInputShow"
                      class="w70 margin-left-10"
                    ></el-input>
                    <el-button
                      type="text"
                      size="small"
                      v-if="particularTools.stockInputShow"
                      @click="handleParticularSetStockSubmit"
                      >保存</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      v-if="particularTools.stockInputShow"
                      @click="handleParticularSetStockCancel"
                      >取消</el-button
                    >
                  </div>
                </div>
              </el-form-item>
            </template>
            <el-form-item
              label="价格"
              required
              :show-message="false"
              style="display: none"
            >
              <el-input
                type="number"
                v-model="formData.baseInfo.price"
                class="w150"
                @change="handlePriceChange"
              >
                <template slot="prepend">
                  <el-select v-model="unit">
                    <el-option
                      v-for="(row, rowIndex) in unitOptions"
                      :value="row.value"
                      :label="row.label"
                      :key="rowIndex"
                    ></el-option>
                  </el-select>
                </template>
              </el-input>
            </el-form-item>
            <template v-if="formData.baseInfo.type === 1">
              <el-form-item label="单位" required :show-message="false">
                <el-input
                  type="text"
                  v-model="formData.baseInfo.remark"
                  class="w120"
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item
              label="积分"
              required
              :show-message="false"
              v-for="(item, index) in formData.baseInfo.pointsItemsWayList"
              :key="index"
            >
              <el-input
                type="number"
                v-model="item.points"
                class="w120"
              ></el-input>
              <span style="margin: 0 10px">+</span>
              <el-input
                type="number"
                v-model="item.price"
                class="w120"
              ></el-input>
              <span style="margin-left: 5px">元</span>
              <span
                style="margin-left: 5px; cursor: pointer"
                @click="handleAddPointsMethod"
              >
                <i
                  class="el-icon-circle-plus-outline"
                  style="font-size: 20px"
                ></i>
              </span>
              <span
                style="margin-left: 5px; cursor: pointer"
                @click="handleDeletePointsMethod"
              >
                <i class="el-icon-remove-outline" style="font-size: 20px"></i>
              </span>
            </el-form-item>
            <el-form-item label="库存" required :show-message="false">
              <el-input
                type="number"
                v-model="formData.baseInfo.stock"
                class="w120"
                :disabled="
                  formData.baseInfo.type === 0 && formData.baseInfo.stock > -1
                "
              ></el-input>
              <span class="tips" style="margin-left: 5px"
                >库存为 0 时，会放到 [已兑完] 的列表里</span
              >
            </el-form-item>
            <el-form-item label="兑换说明" required :show-message="false">
              <el-input
                type="textarea"
                :rows="4"
                v-model="formData.baseInfo.exchangeContent"
                class="w300"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="form-button-wrap">
          <el-button type="primary" size="small" @click="handleChangeStep(2)"
            >下一步</el-button
          >
        </div>
      </el-form>
    </div>

    <!-- step 2 -->
    <div class="step-content" v-show="step == 2">
      <el-form
        size="small"
        ref="detailFormData"
        label-width="150px"
        class="content-form"
      >
        <!-- 基本信息 -->
        <div class="form-module">
          <div class="module-header">商品详情</div>
          <div class="module-body">
            <el-form-item label="详情图" required :show-message="false">
              <div class="pics-box pics-box-detail">
                <el-upload
                  :action="uploadPicUrl"
                  list-type="picture-card"
                  :file-list="detailUploadPicList"
                  accept=".png,.jpg,.jpeg"
                  drag
                  :on-preview="handleDetailPicturesPreview"
                  :on-remove="handleDetailPicturesRemove"
                  :on-success="handleDetailPicturesSuccess"
                  :on-error="handleDetailPicturesError"
                  :before-upload="handleDetailPicturesBeforeUpload"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <p class="tips">
                支持jpg、png格式，上传数量不限，单张图片不超过2M
              </p>
            </el-form-item>
          </div>
        </div>

        <div class="form-button-wrap">
          <el-button type="default" size="small" @click="handleChangeStep(1)"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="handleFormSubmit('formData')"
            :loading="submitLoading"
            >保存</el-button
          >
        </div>
      </el-form>
    </div>

    <!-- 规格拖动排序 dialog -->
    <el-dialog
      title="拖动规格值进行排序"
      :visible.sync="specificationSortDialogShow"
      width="400px"
      custom-class="sort-dialog"
      @opened="handleSpecificationDialogOpened"
      @close="handleSpecificationDialogClose"
    >
      <el-form
        size="small"
        label-width="80px"
        label-position="top"
        class="dialog-form"
      >
        <el-form-item
          v-for="(itemName, itemNameIndex) in formData.baseInfo.specification
            .listClone"
          :key="itemNameIndex"
          :label="itemName.name"
        >
          <p
            :class="'sort-item sort-item-' + itemNameIndex"
            v-for="(itemValue, itemValueIndex) in itemName.valueNameList"
            :key="itemValueIndex + 1"
            :data-nindex="itemNameIndex"
            :data-vindex="itemValueIndex"
          >
            {{ itemValue.name }}
          </p>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="handleSpecificationDialogHide"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="handleSpecificationDialogSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog
      :visible.sync="previewDialogShow"
      custom-class="preview-image-dialog"
    >
      <img width="100%" :src="previewDialogImageUrl" alt="" />
    </el-dialog>

    <!-- 视频预览 -->
    <el-dialog
      :visible.sync="previewVideoDialogShow"
      custom-class="preview-video-dialog"
    >
      <video
        width="100%"
        style="height: calc(70vh - 60px)"
        :src="previewVideoDialogUrl"
        controls
        alt=""
      ></video>
    </el-dialog>
  </section>
</template>

<script>
import {
  BASE,
  commodityCategoryList,
  commodityCategoryLabelList,
  commoditySpecificationList,
  commoditySpecificationValueAdd,
  commodityShippingTemplateList,
  commodityDetail,
  validGoodsName,
  commodityOptionWarehouseList,
  commodityOptionRegionList,
  commodityOptionRateList,
} from "@/common/api";
import {
  pointsSaveOrUpdateProduct,
  pointsSaveOrUpdateService,
} from "@/common/api";
import { serviceManageDetail } from "@/common/api";

export default {
  name: "goodsManageAdd",
  data() {
    return {
      id: this.$route.query.id || "",
      pointId: this.$route.query.pointId || "",
      pointType: this.$route.query.pointType || "",
      pageLoading: true,
      step: 1, // 当前步骤
      sonTypeData: [
        { value: 1, label: "接机券" },
        { value: 2, label: "送机券" },
      ],
      formData: {
        // 表单数据
        baseInfo: {
          // 基本信息
          pointType: 0, // 创建类型 0、商品 1、卷 2、权益
          sonType: 1, // 权益类型 1、接机券 2、送机券
          day: "", //券码有效期
          type: 0, // 0: 实体商品； 1: 虚拟商品
          abroadType: 1, // 1: 国内； 2: 国外
          syncSys: 1, // 1: 国内； 2: 国外
          regionId: "", // 产地
          rateId: "", // 税率
          includeTax: "",
          warehouseId: "", // 仓库
          name: "", // 商品名
          code: "", // 商品编码
          categoryList: [
            {
              firstCategoryId: "",
              secondCategoryId: "",
              categoryLabelId: "",
              secondCategoryOptions: [],
              categoryLabelOptions: [],
            },
          ],
          sellingPoint: "", // 卖点
          pics: [], // 图
          tags: [
            {
              label: "",
            },
          ], // 标签
          specification: {
            showSortButton: false, // 是否显示自定义排序按钮
            list: [
              // {
              //     id: '',
              //     name: '', // 规格名
              //     valueNameList: [  // 已选规格值列表
              //         {
              //             name: '',
              //             valueOptions: [] // 规格值下拉列表
              //         }
              //     ]
              // }
            ],

            listClone: [],

            particularData: [
              // 规格明细
              // {
              //     firstValue: '',
              //     secondValue: '',
              //     thirdValue: '',
              //     price: '',
              //     stock: '',
              //     skuCode: '',
              //     cost: '',
              //     presetSale: 0
              // }
            ],
          }, // 商品规格
          price: "", // 价格
          nickPrice: "", //划线价
          stock: "", // 库存
          presetSale: "", //预售销量
          remark: "",
          points: "",
          pointsPrice: "2.99", // 积分兑换附加金额，默认2.99，有值后根据接口赋值
          exchangeContent: "",
          pointsItemsWayList: [
            {
              points: "",
              price: "",
            },
          ],
        },

        deliverInfo: {
          // 物流信息
          deliverType: "0", // 配送方式
          feeType: "", // 收费类型
          deliverFee: "", // 运费
          shippingTemplatesId: "", // 运费模板
          showWeight: false, // 是否显示重量
          weightType: "0", // 重量类型
          weight: "", // 重量
        },
      },
      submitLoading: false,

      // 主图视频
      videosLimit: 1,
      uploadVideoList: [],
      previewVideoDialogShow: false,
      previewVideoDialogUrl: "",

      firstCategoryOptions: [], // 商品类目列表
      firstCategoryOptionsLoading: true,

      specificationPicsUploadVisible: false, // 添加图片
      specificationOptions: [], // 规格数据
      specificationNameOptions: [], // 下拉规格名列表
      specificationValueOptions: [], // 下拉规格值列表
      specificationOptionsLoading: true,

      localParticularData: [], // 本地缓存的规格明细数据

      particularTools: {
        // 规格明细批量设置
        price: "", // 批量设置价格
        priceInputShow: false, //
        stock: "", // 批量设置库存
        stockInputShow: false,
        weight: "",
        weightInputShow: false,
      },

      uploadPicUrl: BASE + "/commodity/uploadPic", // 图片上传地址
      previewDialogShow: false,
      previewDialogImageUrl: "",
      // 商品图
      picsLimit: 6,
      uploadPicList: [],
      // 规格图片
      specificationPicsLimit: 1,
      // 详情图片
      detailPics: [],
      detailUploadPicList: [],

      warehouseOptions: [], // 仓库
      warehouseOptionsLoading: false,
      regionOptions: [], // 产地
      regionOptionsLoading: false,
      rateOptions: [], // 税率
      rateOptionsLoading: false,

      shippingTemplatesOptions: [], // 运费模版下拉列表
      shippingTemplatesOptionsLoading: true,

      specificationSortDialogShow: false, // 规格排序弹窗显隐
      sorting: false,

      unit: 0,
      unitOptions: [
        {
          value: 0,
          label: "￥",
        },
        {
          value: 1,
          label: "₩",
        },
      ],
    };
  },
  watch: {
    /**
     * [description] 监听图片数量变化，绑定排序事件
     * @param    val [description]
     * @return       [description]
     */
    uploadPicList: function (val) {
      this.watchUploadPicList();
    },
    /**
     * [description] 监听详情图片数量变化，绑定排序事件
     * @param    val [description]
     * @return       [description]
     */
    detailUploadPicList: function (val) {
      this.watchDetailUploadPicList();
    },
  },
  mounted() {
    this.getWarehouseList();
    this.getRegionList();
    this.getRateList();
    this.handleGetSpecificationList();
    // this.getFirstCategoryList();
    // this.handleGetCommodityShippingTemplateList();
  },
  methods: {
    // 添加价格选项
    handleAddPointsMethod() {
      let item = {
        points: "",
        price: "",
      };
      this.formData.baseInfo.pointsItemsWayList.push(item);
    },
    // 删除价格选项
    handleDeletePointsMethod(index) {
      if (this.formData.baseInfo.pointsItemsWayList.length <= 1) {
        this.$message.warning("最少保留一个");
        return;
      }
      this.formData.baseInfo.pointsItemsWayList.splice(index, 1);
    },
    // 获取仓库
    getWarehouseList: function (isRefresh) {
      this.warehouseOptionsLoading = true;
      commodityOptionWarehouseList({}).then((res) => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.warehouseOptions = data || [];
          this.warehouseOptionsLoading = false;
        }
      });
    },
    /**
     * [getRegionList description] 获取产地
     * @return           [description]
     */
    getRegionList: function (isRefresh) {
      this.regionOptionsLoading = true;
      commodityOptionRegionList({}).then((res) => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.regionOptions = data || [];
          this.regionOptionsLoading = false;
        }
      });
    },
    /**
     * [getRateList description] 获取税率
     * @return           [description]
     */
    getRateList: function (isRefresh) {
      this.rateOptionsLoading = true;
      commodityOptionRateList({}).then((res) => {
        let { code, data, msg } = res;
        if (code == 0) {
          if (data && data.length > 0) {
            data.map((row) => {
              row.rateLabel = row.rate + "%";
            });
          }
          this.rateOptions = data || [];
          this.rateOptionsLoading = false;
        }
      });
    },
    /**
     * [handleValidGoodsName description] 校验商品名称是否重复
     * @return   [description]
     */
    handleValidGoodsName: function () {
      let params = {
        id: this.id,
        name: this.formData.baseInfo.name,
      };

      validGoodsName(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code != 0) {
            this.$message.error(msg);
          }
        })
        .catch((error) => {});
    },
    /**
     * [watchUploadPicList description] 图片数量变化，绑定排序事件
     * @return   [description]
     */
    watchUploadPicList: function () {
      this.formData.baseInfo.pics = [];
      for (let i = 0; i < this.uploadPicList.length; i++) {
        // this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.url);
        this.formData.baseInfo.pics.push(
          this.uploadPicList[i].response.data.path,
        );
      }

      this.$nextTick(function () {
        this.handlePicListSort();
      });
    },
    /**
     * [watchDetailUploadPicList description] 详情图片数量变化，绑定排序事件
     * @return   [description]
     */
    watchDetailUploadPicList: function () {
      this.detailPics = [];
      for (let i = 0; i < this.detailUploadPicList.length; i++) {
        // this.detailPics.push(this.detailUploadPicList[i].response.data.url);
        this.detailPics.push(this.detailUploadPicList[i].response.data.path);
      }

      this.$nextTick(function () {
        this.handleDetailPicListSort();
      });
    },
    /**
     * [handleChangeGoodsType description] 切换商品类型
     * @param    type [description]
     * @return        [description]
     */
    handleChangeGoodsType: function (type) {
      let goodsType = this.formData.baseInfo.type;

      if (goodsType == type) {
        return false;
      }

      this.formData.baseInfo.type = type;
    },
    /**
     * [getDetail description] 获取详情
     * @return   [description]
     */
    getDetail: function () {
      if (!this.id) {
        this.pageLoading = false;
        this.handleCreateSpecificationNameOptions();
        return false;
      }

      this.pageLoading = true;

      if (this.pointType == "0" || this.pointType == "2") {
        // 商品
        let params = {
          id: this.id,
          type: 1,
        };

        commodityDetail(params)
          .then((res) => {
            let { code, data, msg } = res;
            if (code == 0) {
              this.pageLoading = false;

              this.formData.baseInfo.regionId = data.regionId
                ? "" + data.regionId
                : "";
              this.formData.baseInfo.rateId = data.rateId
                ? "" + data.rateId
                : "";
              this.formData.baseInfo.includeTax = data.includeTax
                ? "" + data.includeTax
                : "";
              this.formData.baseInfo.warehouseId = data.warehouseId
                ? "" + data.warehouseId
                : "";

              this.formData.baseInfo.name = data.name;
              // this.formData.baseInfo.type = Number(this.pointType);
              this.formData.baseInfo.abroadType = data.abroadType;
              this.formData.baseInfo.syncSys = data.abroadType;
              this.formData.baseInfo.code = data.code;
              // this.formData.baseInfo.points = data.points;
              this.formData.baseInfo.exchangeContent = data.exchangeContent;

              this.formData.baseInfo.pointType = data.pointType;
              this.formData.baseInfo.sonType = data.sonType;
              this.formData.baseInfo.day = data.day;

              // 商品类目
              if (data.categoryLabelCommodityList.length > 0) {
                let categoryArr = [];

                for (
                  let i = 0;
                  i < data.categoryLabelCommodityList.length;
                  i++
                ) {
                  let item = data.categoryLabelCommodityList[i];

                  categoryArr.push({
                    firstCategoryId: "" + item.firstCategoryId,
                    secondCategoryId: "" + item.secondCategoryId,
                    categoryLabelId: "" + item.categoryLabelId,
                    secondCategoryOptions: [],
                    categoryLabelOptions: [],
                  });
                }

                this.formData.baseInfo.categoryList = categoryArr;
                this.handleGetCategoryOptions();
              }

              // 卖点
              this.formData.baseInfo.sellingPoint = data.sellingPoint;

              // 主图视频
              if (data.mainVideo) {
                let picsItemArr = data.mainVideoPath.split("/"),
                  picsItemName = picsItemArr[picsItemArr.length - 1];
                this.uploadVideoList = [
                  {
                    name: picsItemName,
                    percentage: 100,
                    status: "success",
                    url: data.mainVideoPath,
                    response: {
                      data: {
                        path: data.mainVideoPath,
                        url: data.mainVideo,
                      },
                    },
                  },
                ];
              }

              // 商品图
              let picsList = data.listPic;
              if (picsList.length == 0) {
                this.formData.baseInfo.pics = [];
                this.uploadPicList = [];
              } else {
                for (let i = 0; i < picsList.length; i++) {
                  let picsItem = picsList[i],
                    picsItemArr = picsItem.url.split("/"),
                    picsItemName = picsItemArr[picsItemArr.length - 1];

                  this.formData.baseInfo.pics.push(picsItem.url);
                  this.uploadPicList.push({
                    name: picsItemName,
                    percentage: 100,
                    status: "success",
                    url: picsItem.path,
                    response: {
                      data: {
                        url: picsItem.path,
                        path: picsItem.url,
                      },
                    },
                  });
                }

                this.watchUploadPicList();
              }

              // 标签
              if (data.labels && data.labels.length > 0) {
                let tagsArr = [];

                for (let i = 0; i < data.labels.length; i++) {
                  tagsArr.push({
                    label: data.labels[i],
                  });
                }

                this.formData.baseInfo.tags = tagsArr;
              }

              // 商品规格
              if (data.specificationJson.length > 0) {
                let specificationArr = [];
                for (let i = 0; i < data.specificationJson.length; i++) {
                  let item = data.specificationJson[i],
                    valueNameList = [];

                  if (i == 0 && item.valueNameList.length > 0) {
                    // 判断第一组规格是否有图
                    let num = 0;
                    for (let j = 0; j < item.valueNameList.length; j++) {
                      let valueItem = item.valueNameList[j];

                      if (valueItem.url) {
                        valueNameList.push({
                          name: valueItem.name,
                          picList: [
                            {
                              name: valueItem.path,
                              percentage: 100,
                              status: "success",
                              url: valueItem.path,
                              response: {
                                data: {
                                  url: valueItem.url,
                                  path: valueItem.path,
                                },
                              },
                            },
                          ],
                        });

                        num += 1;
                      } else {
                        valueNameList.push({
                          name: valueItem.name,
                          picList: [],
                        });
                      }
                    }

                    this.specificationPicsUploadVisible =
                      num > 0 ? true : false;
                  } else {
                    valueNameList = item.valueNameList;
                  }

                  specificationArr.push({
                    id: "" + item.id,
                    name: item.name,
                    valueNameList: valueNameList,
                  });
                }

                this.formData.baseInfo.specification.list = specificationArr;
                this.formData.baseInfo.specification.showSortButton = true;
              }
              this.handleCreateSpecificationNameOptions();
              this.handleCreateSpecificationValueOptions();

              // 规格明细
              for (let i = 0; i < data.specificationDetailJson.length; i++) {
                let item = data.specificationDetailJson[i];

                if (item.weight == 0) {
                  item.weight = "";
                }

                this.formData.baseInfo.specification.particularData.push(item);
              }
              this.updateLocalParticularData();

              this.unit = data.unit || 0;
              if (this.unit == 0) {
                // 人民币
                this.formData.baseInfo.price = data.price;
                this.formData.baseInfo.nickPrice = data.nickPrice;
              } else if (this.unit == 1) {
                // 韩币
                this.formData.baseInfo.price = data.koreaPrice;
                this.formData.baseInfo.nickPrice = data.koreaNickPrice;
              }
              this.formData.baseInfo.remark = data.remark;
              this.formData.baseInfo.stock = data.stock;
              this.formData.baseInfo.exchangeContent = data.exchangeContent;
              this.formData.baseInfo.presetSale = data.presetSale;
              // this.formData.baseInfo.points = data.points;
              // this.formData.baseInfo.pointsPrice = Number(data.pointsPrice);
              this.formData.baseInfo.pointsItemsWayList =
                data.pointsItemsWayList;

              // 物流信息设置
              let deliverInfo = data.commodityDeliverVo;
              if (deliverInfo) {
                this.formData.deliverInfo.deliverType =
                  "" + deliverInfo.deliverType;
                this.formData.deliverInfo.feeType = "" + deliverInfo.feeType;
                this.formData.deliverInfo.deliverFee = deliverInfo.deliverFee;
                this.formData.deliverInfo.shippingTemplatesId =
                  deliverInfo.shippingTemplatesId
                    ? "" + deliverInfo.shippingTemplatesId
                    : "";
                this.handleDeliverWeightTypeChange(
                  deliverInfo.shippingTemplatesId,
                );
                this.formData.deliverInfo.weightType =
                  "" + deliverInfo.weightType;
                this.formData.deliverInfo.weight =
                  deliverInfo.weightType == "0" &&
                  data.specificationDetailJson.length > 0
                    ? data.specificationDetailJson[0].weight
                    : "";
                this.formData.deliverInfo.showWeight =
                  deliverInfo.feeType == 1 && deliverInfo.templateType == 2
                    ? true
                    : false;
              } else {
                this.formData.baseInfo.deliverInfo = {
                  deliverType: "0",
                  feeType: "",
                  deliverFee: "",
                  shippingTemplatesId: "",
                  showWeight: false,
                  weightType: "0",
                  weight: "",
                };
              }

              // 详情图
              if (data.detailPic.length == 0) {
                this.detailPics = [];
                this.detailUploadPicList = [];
              } else {
                for (let i = 0; i < data.detailPic.length; i++) {
                  let picsItem = data.detailPic[i];

                  this.detailPics.push(picsItem.url);
                  this.detailUploadPicList.push({
                    name: picsItem.path,
                    percentage: 100,
                    status: "success",
                    url: picsItem.path,
                    response: {
                      data: {
                        url: picsItem.path,
                        path: picsItem.url,
                      },
                    },
                  });
                }

                this.watchDetailUploadPicList();
              }
            } else {
              this.$message.error(msg);
            }
          })
          .catch((error) => {
            this.$message.error("传值异常");
          });
      } else if (this.pointType == "1") {
        // 项目
        let params = {
          serviceId: this.id,
          type: 1,
        };

        serviceManageDetail(params)
          .then((res) => {
            let { code, data, msg } = res;

            if (code == 0) {
              this.pageLoading = false;

              this.formData.baseInfo.name = data.name;
              this.formData.baseInfo.type = Number(data.type);

              // 商品类目
              if (data.catList.length > 0) {
                let categoryArr = [];

                for (let i = 0; i < data.catList.length; i++) {
                  let item = data.catList[i];

                  categoryArr.push({
                    firstCategoryId: "" + item.firstCategoryId,
                    secondCategoryId: "" + item.secondCategoryId,
                    secondCategoryOptions: [],
                  });
                }

                this.formData.baseInfo.categoryList = categoryArr;
                this.handleGetCategoryOptions();
              }

              // 主图视频
              if (data.mainVideo) {
                let picsItemArr = data.mainVideoPath.split("/"),
                  picsItemName = picsItemArr[picsItemArr.length - 1];
                this.uploadVideoList = [
                  {
                    name: picsItemName,
                    percentage: 100,
                    status: "success",
                    url: data.mainVideoPath,
                    response: {
                      data: {
                        path: data.mainVideoPath,
                        url: data.mainVideo,
                      },
                    },
                  },
                ];
              }

              // 商品图
              let picsList = data.picList;
              let picPathList = data.picPathList;
              if (picsList.length == 0) {
                this.formData.baseInfo.pics = [];
                this.uploadPicList = [];
              } else {
                for (let i = 0; i < picsList.length; i++) {
                  let picsItem = picsList[i],
                    picsItemArr = picsItem.split("/"),
                    picsItemName = picsItemArr[picsItemArr.length - 1];

                  this.formData.baseInfo.pics.push(picsItem);
                  this.uploadPicList.push({
                    name: picsItemName,
                    percentage: 100,
                    status: "success",
                    url: picPathList[i],
                    response: {
                      data: {
                        path: picPathList[i],
                        url: picsItem,
                      },
                    },
                  });
                }

                this.watchUploadPicList();
              }

              // 标签
              if (data.labels && data.labels.length > 0) {
                let tagsArr = [];

                for (let i = 0; i < data.labels.length; i++) {
                  tagsArr.push({
                    label: data.labels[i],
                  });
                }

                this.formData.baseInfo.tags = tagsArr;
              }

              this.formData.baseInfo.points = data.points;
              this.formData.baseInfo.exchangeContent = data.exchangeContent;
              this.formData.baseInfo.remark = data.remark;
              this.formData.baseInfo.orderType = data.orderType;
              this.unit = data.unit || 0;
              if (this.unit == 0) {
                // 人民币
                this.formData.baseInfo.price = data.price;
                this.formData.baseInfo.nickPrice = data.linePrice;
              } else if (this.unit == 1) {
                // 韩币
                this.formData.baseInfo.price = data.koreaPrice;
                this.formData.baseInfo.nickPrice = data.lineKoreaPrice;
              }
              this.formData.baseInfo.stock = data.stock;

              // 详情图
              if (data.pics.length == 0) {
                this.detailPics = [];
                this.detailUploadPicList = [];
              } else {
                for (let i = 0; i < data.pics.length; i++) {
                  let picsItem = data.pics[i],
                    picsItemArr = picsItem.split("/"),
                    picsItemName = picsItemArr[picsItemArr.length - 1];
                  let picsPathItem = data.picsPath[i];

                  this.detailPics.push(picsItem);
                  this.detailUploadPicList.push({
                    name: picsItemName,
                    percentage: 100,
                    status: "success",
                    url: picsPathItem,
                    response: {
                      data: {
                        path: picsPathItem,
                        url: picsItem,
                      },
                    },
                  });
                }

                this.watchDetailUploadPicList();
              }
            } else {
              this.$message.error(msg);
            }
          })
          .catch((error) => {
            this.$message.error("服务器异常");
          });
      }
    },
    /**
     * [handleGetCategoryOptions description] 获取二类目、类目标签下拉列表
     * @return   [description]
     */
    handleGetCategoryOptions: function () {
      let list = this.formData.baseInfo.categoryList;

      if (list.length == 0) {
        return false;
      }

      for (let i = 0; i < list.length; i++) {
        this.handleFirstCategoryChange(i);
        this.handleSecondCategoryChange(i);
      }
    },
    /**
     * [handleCategoryAdd description] 添加类目
     * @return   [description]
     */
    handleCategoryAdd: function () {
      this.formData.baseInfo.categoryList.push({
        firstCategoryId: "",
        secondCategoryId: "",
        categoryLabelId: "",
        secondCategoryOptions: [],
        categoryLabelOptions: [],
      });
    },
    /**
     * [handleCategoryDelete description] 删除类目
     * @param    index [description]
     * @return         [description]
     */
    handleCategoryDelete: function (index) {
      this.formData.baseInfo.categoryList.splice(index, 1);
    },
    /**
     * [getFirstCategoryList description] 获取商品类目
     * @param    isRefresh [description] 表示这个操作是刷新
     * @return           [description]
     */
    getFirstCategoryList: function (isRefresh) {
      this.firstCategoryOptionsLoading = true;

      let params = {
        type: 1,
      };

      commodityCategoryList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          this.firstCategoryOptions = dataArray;
          this.firstCategoryOptionsLoading = false;

          if (isRefresh) {
            this.$message({ message: "商品类目已刷新", type: "success" });
          }
        }
      });
    },
    /**
     * [handleCommidityCategoryChange description] 监测一级类目下拉框值变化
     * @param    val [description]
     * @return       [description]
     */
    handleFirstCategoryChange: function (index, type) {
      if (type == "user") {
        this.formData.baseInfo.categoryList[index].secondCategoryId = "";
        this.formData.baseInfo.categoryList[index].categoryLabelId = "";
      }

      let categoryList = this.formData.baseInfo.categoryList,
        firstCategoryId = categoryList[index].firstCategoryId;

      let params = {
        type: 1,
        firstCategoryId: firstCategoryId,
      };

      commodityCategoryList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          categoryList[index].secondCategoryOptions = dataArray;
        }
      });
    },
    /**
     * [handleSecondCategoryChange description] 监测二级类目下拉框值变化
     * @param    index [description]
     * @return         [description]
     */
    handleSecondCategoryChange: function (index, type) {
      if (type == "user") {
        this.formData.baseInfo.categoryList[index].categoryLabelId = "";
      }

      let categoryList = this.formData.baseInfo.categoryList,
        secondCategoryId = categoryList[index].secondCategoryId;

      let params = {
        secondCategoryId: secondCategoryId,
      };

      commodityCategoryLabelList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          categoryList[index].categoryLabelOptions = dataArray;
        }
      });
    },
    /**
     * [handleTagsAdd description] 添加标签
     * @return   [description]
     */
    handleTagsAdd: function () {
      this.formData.baseInfo.tags.push({
        label: "",
      });
    },
    /**
     * [handleTagsDelete description] 移除标签
     * @param    index [description]
     * @return         [description]
     */
    handleTagsDelete: function (index) {
      this.formData.baseInfo.tags.splice(index, 1);
    },
    /**
     * [handleGetCommidityCategoryVo description] 获取规格列表
     * @param    categoryId [description]
     * @return              [description]
     */
    handleGetSpecificationList: function () {
      let params = {};

      commoditySpecificationList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.specificationOptions = data || [];

          this.getDetail();
        }
      });
    },
    /**
     * [handleCreateSpecificationNameOptions description] 创建规格名的下拉列表，剔除已选中的规格名
     * @return   [description]
     */
    handleCreateSpecificationNameOptions: function () {
      this.specificationNameOptions = [];

      if (this.specificationOptions.length > 0) {
        for (let i = 0; i < this.specificationOptions.length; i++) {
          let item = this.specificationOptions[i];

          if (!this.handleCheckSpecificationNameIsExits(item.name)) {
            this.specificationNameOptions.push({
              id: item.id,
              name: item.name,
            });
          }
        }
      }
    },
    /**
     * [handleCheckSpecificationNameIsExits description] 校验规格名是否已在已选中规格名里面
     * @param    name [description]
     * @return        [description]
     */
    handleCheckSpecificationNameIsExits: function (name) {
      let list = this.formData.baseInfo.specification.list;

      if (list.length == 0) {
        return false;
      }

      for (let i = 0; i < list.length; i++) {
        if (list[i].name == name) {
          return true;
        }

        if (i == list.length - 1) {
          return false;
        }
      }
    },
    /**
     * [handleCreateSpecificationValueOptions description] 在已选择的规格值列表中循环插入规格值下拉列表
     * @return   [description]
     */
    handleCreateSpecificationValueOptions: function () {
      let list = this.formData.baseInfo.specification.list,
        listClone = [];

      if (list.length == 0) {
        return false;
      }

      // 循环选中规格名列表
      for (let i = 0; i < list.length; i++) {
        let values = list[i].valueNameList;

        if (values.length > 0) {
          //循环选中规格值列表
          for (let j = 0; j < values.length; j++) {
            // 每个规格值item添加下拉列表
            values[j].valueOptions =
              this.handleCreateSpecificationValueOptionsItem(i, list[i].name);
          }
        }
      }
    },
    /**
     * [handleCreateSpecificationValueOptionsItem description] 根据规格名创建规格值的下拉列表，剔除已选中的规格值
     * @param    nameIndex [description] 规格名的索引
     * @param    name      [description] 规格名
     * @return             [description]
     */
    handleCreateSpecificationValueOptionsItem: function (nameIndex, name) {
      let valueOptions = [];

      // 循环元数据规格名列表
      for (let i = 0; i < this.specificationOptions.length; i++) {
        // 元数据规格名 == 选中规格名
        if (this.specificationOptions[i].name == name) {
          let nameValues = this.specificationOptions[i].nameValues;

          // 循环元数据规格名下的规格值列表
          for (let j = 0; j < nameValues.length; j++) {
            // 若元数据规格名下的规格值列表中的规格值存在于已选中规格值列表中
            if (
              !this.handleCheckSpecificationValuesIsExits(
                nameIndex,
                nameValues[j],
              )
            ) {
              valueOptions.push({
                name: nameValues[j],
              });
            }
          }

          return valueOptions;
        }
      }
    },
    /**
     * [handleCheckSpecificationValuesIsExits description] 校验规格值是否已在已选中规格值里面
     * @param    nameIndex [description] 规格名的索引
     * @param    value     [description] 元数据规格名下的规格值列表中的规格值
     * @return             [description]
     */
    handleCheckSpecificationValuesIsExits: function (nameIndex, value) {
      let list =
        this.formData.baseInfo.specification.list[nameIndex].valueNameList; //已选中规格明下的已选中规格值列表

      // 长度为0 =》不存在
      if (list.length == 0) {
        return false;
      }

      for (let i = 0; i < list.length; i++) {
        // 值相同 =》存在
        if (list[i].name == value) {
          return true;
        }

        // 没找到 =》不存在
        if (i == list.length - 1) {
          return false;
        }
      }
    },
    /**
     * [handleSpecificationAdd description] 商品规格添加模块
     * @param    index [description] 当前模块数据的索引
     * @return         [description]
     */
    handleSpecificationAdd: function () {
      this.formData.baseInfo.specification.list.push({
        id: "",
        name: "", // 规格名
        valueNameList: [
          {
            name: "",
            picList: [],
            valueOptions: [],
          },
        ], // 规格值
      });

      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
    },
    /**
     * [handleSpecificationDelete description] 商品规格名删除模块
     * @param    index [description] 当前模块数据的索引
     * @return         [description]
     */
    handleSpecificationDelete: function (index) {
      this.formData.baseInfo.specification.list.splice(index, 1);

      this.handleCreateSpecificationNameOptions();
      this.handlePackageSpecificationToParticular();
      this.handleSpecificationValuesChange();
    },
    /**
     * [handleSpecificationChange description] 商品规格-规格名变化
     * @param    index [description]
     * @return         [description]
     */
    handleSpecificationChange: function (index) {
      this.formData.baseInfo.specification.list[index].valueNameList = [
        {
          name: "",
          picList: [],
          valueOptions: [],
        },
      ];

      this.handleGetSpecificationID(index);
      this.handleCreateSpecificationNameOptions();
      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
    },
    /**
     * [handleGetSpecificationID description] 获取规格名name
     * @param    index [description]
     * @return         [description]
     */
    handleGetSpecificationID: function (index) {
      let name = this.formData.baseInfo.specification.list[index].name;

      for (let i = 0; i < this.specificationOptions.length; i++) {
        if (this.specificationOptions[i].name == name) {
          this.formData.baseInfo.specification.list[index].id =
            "" + this.specificationOptions[i].id;
          break;
        }
      }
    },
    /**
     * [handleSpecificationValuesAdd description] 商品规格-添加规格值
     * @param    index [description] 规格的索引
     * @return         [description]
     */
    handleSpecificationValuesAdd: function (index) {
      this.formData.baseInfo.specification.list[index].valueNameList.push({
        name: "",
        picList: [],
        valueOptions: [],
      });

      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
    },
    /**
     * [handleSpecificationValuesDelete description] 商品规格-删除规格值
     * @param    index      [description] 规格的索引
     * @param    valueIndex [description] 规格值的索引
     * @return              [description]
     */
    handleSpecificationValuesDelete: function (index, valueIndex) {
      this.formData.baseInfo.specification.list[index].valueNameList.splice(
        valueIndex,
        1,
      );

      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
      this.handleSpecificationValuesChange();
    },
    /**
     * [handleSpecificationValuesSelectChange description] 规格值下拉框值变化
     * @param    listIndex  [description]
     * @param    valueIndex [description]
     * @return              [description]
     */
    handleSpecificationValuesSelectChange: function (listIndex, valueIndex) {
      let list = this.formData.baseInfo.specification.list,
        id = list[listIndex].id,
        valueNameList = list[listIndex].valueNameList,
        valueName = valueNameList[valueIndex].name;

      for (let i = 0; i < this.specificationOptions.length; i++) {
        if (this.specificationOptions[i].id == id) {
          let nameValues = this.specificationOptions[i].nameValues;

          if (nameValues.indexOf(valueName) < 0) {
            // 规格值为新添
            valueNameList[valueIndex].loading = true;

            let params = {
              skuOptionsNameId: id,
              name: valueName,
            };

            commoditySpecificationValueAdd(params).then((res) => {
              let { code, data, msg } = res;

              if (code == 0) {
                valueNameList[valueIndex].loading = false;
                nameValues.push(valueName);
                this.handleSpecificationValuesChange();
              } else {
                valueNameList[valueIndex].loading = false;
                valueNameList.splice(valueIndex, 1);
              }
            });
          } else {
            this.handleSpecificationValuesChange();
          }

          break;
        }
      }
    },
    /**
     * [handleSpecificationValuesChange description] 检测规格值变化，控制自定义排序按钮显示隐藏（规格模块删除、规格值删除、规格值选择 3种情形下触发）
     * @return   [description]
     */
    handleSpecificationValuesChange: function () {
      this.formData.baseInfo.specification.showSortButton = false;

      let list = this.formData.baseInfo.specification.list;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let valueCount = 0,
            values = list[i].valueNameList;

          if (values.length > 0) {
            for (let j = 0; j < values.length; j++) {
              if (values[j].name) {
                valueCount += 1;
              }

              if (j == values.length - 1) {
                if (valueCount == 1) {
                  this.formData.baseInfo.specification.showSortButton = false;

                  this.handleCreateSpecificationValueOptions();
                  this.handlePackageSpecificationToParticular();

                  break;
                } else if (valueCount > 1) {
                  this.formData.baseInfo.specification.showSortButton = true;

                  this.handleCreateSpecificationValueOptions();
                  this.handlePackageSpecificationToParticular();

                  break;
                }
              }
            }
          }
        }
      }
    },
    /**
     * [handlePackageSpecificationToParticular description] 将规格数据封装成明细列表
     * @return   [description]
     */
    handlePackageSpecificationToParticular: function () {
      let list = this.formData.baseInfo.specification.list,
        particularData = [],
        firstLen = this.handleGetSpecificationValuesLenthMethod(0) || 1,
        secondLen = this.handleGetSpecificationValuesLenthMethod(1) || 1,
        thirdLen = this.handleGetSpecificationValuesLenthMethod(2) || 1;

      if (
        this.handleGetSpecificationValuesLenthMethod(0) == 0 &&
        this.handleGetSpecificationValuesLenthMethod(1) == 0 &&
        this.handleGetSpecificationValuesLenthMethod(2) == 0
      ) {
        this.formData.baseInfo.specification.particularData = particularData;
        return false;
      }

      for (let i = 0; i < firstLen; i++) {
        for (let j = 0; j < secondLen; j++) {
          for (let k = 0; k < thirdLen; k++) {
            particularData.push({
              firstValue:
                list[0] && list[0].valueNameList.length > 0
                  ? list[0].valueNameList[i].name
                  : "",
              secondValue:
                list[1] && list[1].valueNameList.length > 0
                  ? list[1].valueNameList[j].name
                  : "",
              thirdValue:
                list[2] && list[2].valueNameList.length > 0
                  ? list[2].valueNameList[k].name
                  : "",
              price: "",
              stock: "",
              skuCode: "",
              cost: "",
              weight: "",
              presetSale: "",
            });
          }
        }
      }

      this.formData.baseInfo.specification.particularData = particularData;

      this.updateLocalParticularData();
    },
    /**
     * [updateLocalParticularData description] 更新本地缓存的规格明细数据
     * @return   [description]
     */
    updateLocalParticularData: function () {
      let newData = this.formData.baseInfo.specification.particularData;

      if (newData.length == 0) {
        return false;
      }

      if (this.localParticularData.length == 0) {
        // 本地缓存为空，直接插入数据
        for (let i = 0; i < newData.length; i++) {
          let newItem = newData[i];

          this.localParticularData.push(newItem);
        }
      } else {
        // 本地缓存不为空，做比较
        for (let i = 0; i < newData.length; i++) {
          let newItem = newData[i],
            newItemArr = [],
            localData = this.localParticularData;

          newItemArr.push(newItem.firstValue || "");
          newItemArr.push(newItem.secondValue || "");
          newItemArr.push(newItem.thirdValue || "");

          for (let j = 0; j < localData.length; j++) {
            let localItem = localData[j],
              localItemArr = [];

            localItemArr.push(localItem.firstValue || "");
            localItemArr.push(localItem.secondValue || "");
            localItemArr.push(localItem.thirdValue || "");

            let newItemArrSort = newItemArr.sort(),
              localItemArrSort = localItemArr.sort();
            if (
              newItemArrSort[0] == localItemArrSort[0] &&
              newItemArrSort[1] == localItemArrSort[1] &&
              newItemArrSort[2] == localItemArrSort[2]
            ) {
              // 新规格 已经存在，不需要更新
              // 判断新规格是否为空，是的话用本地缓存数据更新
              if (
                !newItem.price &&
                !newItem.stock &&
                !newItem.weight &&
                !newItem.skuCode &&
                !newItem.cost &&
                !newItem.presetSale
              ) {
                newItem.price = localItem.price;
                newItem.stock = localItem.stock;
                newItem.weight = localItem.weight;
                newItem.skuCode = localItem.skuCode;
                newItem.cost = localItem.cost;
                newItem.presetSale = localItem.presetSale;
              } else {
                localItem.price = newItem.price;
                localItem.stock = newItem.stock;
                localItem.weight = newItem.weight;
                localItem.skuCode = newItem.skuCode;
                localItem.cost = newItem.cost;
                localItem.presetSale = newItem.presetSale;
              }
              break;
            } else {
              // 新规格 不存在，插入本地缓存
              if (j == localData.length - 1) {
                this.localParticularData.push(newItem);
              }
            }
          }
        }
      }
    },
    /**
     * [handleParticularTableRowMethod description] 合并规格明细表格中相同的规格名
     * @param    options.row         [description]
     * @param    options.column      [description]
     * @param    options.rowIndex    [description]
     * @param    options.columnIndex [description]
     * @return                       [description]
     */
    handleParticularTableRowMethod: function ({
      row,
      column,
      rowIndex,
      columnIndex,
    }) {
      let specificationList = this.formData.baseInfo.specification.list,
        particularData = [],
        firstLen = this.handleGetSpecificationValuesLenthMethod(0) || 1,
        secondLen = this.handleGetSpecificationValuesLenthMethod(1) || 1,
        thirdLen = this.handleGetSpecificationValuesLenthMethod(2) || 1;

      if (
        specificationList[0] &&
        specificationList[0].valueNameList.length > 0 &&
        columnIndex === 0
      ) {
        if (rowIndex % (secondLen * thirdLen) === 0) {
          return {
            rowspan: secondLen * thirdLen,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (
        specificationList[1] &&
        specificationList[1].valueNameList.length > 0 &&
        columnIndex === 1
      ) {
        if (rowIndex % thirdLen === 0) {
          return {
            rowspan: thirdLen,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    /**
     * [handleGetSpecificationValuesLenthMethod description] 获取各个规格名下规格值不为空的规格值长度
     * @param    index [description] 规格名的索引
     * @return         [description]
     */
    handleGetSpecificationValuesLenthMethod: function (index) {
      let specificationList = this.formData.baseInfo.specification.list,
        item = specificationList[index],
        len = 0;

      if (item && item.valueNameList.length > 0) {
        for (let i = 0; i < item.valueNameList.length; i++) {
          if (item.valueNameList[i].name) {
            len += 1;
          }
        }
      }

      return len;
    },
    /**
     * [handleParticularSetPrice description] 规格明细 - 批量设置 - 价格
     * @return   [description]
     */
    handleParticularSetPrice: function () {
      this.particularTools.price = "";
      this.particularTools.priceInputShow = true;
    },
    /**
     * [handleParticularSetPriceSubmit description] 规格明细 - 批量设置 - 价格 - 保存
     * @return   [description]
     */
    handleParticularSetPriceSubmit: function () {
      let particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].price = this.particularTools.price;
      }

      this.particularTools.priceInputShow = false;
      this.handleSetBaseInfoPrice();
    },
    /**
     * [handleParticularSetPriceCancel description] 规格明细 - 批量设置 - 价格 - 取消
     * @return   [description]
     */
    handleParticularSetPriceCancel: function () {
      this.particularTools.priceInputShow = false;
    },
    /**
     * [handleParticularSetStock description] 规格明细 - 批量设置 - 库存
     * @return   [description]
     */
    handleParticularSetStock: function () {
      this.particularTools.stock = "";
      this.particularTools.stockInputShow = true;
    },
    /**
     * [handleParticularSetStockSubmit description] 规格明细 - 批量设置 - 库存 - 保存
     * @return   [description]
     */
    handleParticularSetStockSubmit: function () {
      let particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].stock = this.particularTools.stock;
      }

      this.particularTools.stockInputShow = false;
      this.handleSetBaseInfoStock();
    },
    /**
     * [handleParticularSetStockCancel description] 规格明细 - 批量设置 - 库存 - 取消
     * @return   [description]
     */
    handleParticularSetStockCancel: function () {
      this.particularTools.stockInputShow = false;
    },
    /**
     * [handleParticularSetWeight description] 物流信息 - 批量设置 - 重量
     * @return   [description]
     */
    handleParticularSetWeight: function () {
      this.particularTools.weight = "";
      this.particularTools.weightInputShow = true;
    },
    /**
     * [handleParticularSetWeightSubmit description] 物流信息 - 批量设置 - 重量 - 保存
     * @return   [description]
     */
    handleParticularSetWeightSubmit: function () {
      let particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].weight = this.particularTools.weight;
      }

      this.particularTools.weightInputShow = false;
      this.updateLocalParticularData();
    },
    /**
     * [handleParticularSetWeightCancel description] 物流信息 - 批量设置 - 重量 - 取消
     * @return   [description]
     */
    handleParticularSetWeightCancel: function () {
      this.particularTools.weightInputShow = false;
    },
    /**
     * [handleSpecificationDialogShow description] 规格排序弹窗 - 显示
     * @return   [description]
     */
    handleSpecificationDialogShow: function () {
      this.sorting = false;
      this.formData.baseInfo.specification.listClone = JSON.parse(
        JSON.stringify(this.formData.baseInfo.specification.list),
      );
      this.specificationSortDialogShow = true;
    },
    /**
     * [handleSpecificationDialogHide description] 规格排序弹窗 - 隐藏
     * @return   [description]
     */
    handleSpecificationDialogHide: function () {
      this.specificationSortDialogShow = false;
    },
    /**
     * [handleSpecificationDialogSubmit description] 规格排序弹窗 - 确定
     * @return   [description]
     */
    handleSpecificationDialogSubmit: function () {
      this.sorting = true;
      this.specificationSortDialogShow = false;
    },
    /**
     * [handleSpecificationDialogOpened description] 规格排序弹窗 - 完全打开后触发的事件
     * @return   [description]
     */
    handleSpecificationDialogOpened: function () {
      let listClone = this.formData.baseInfo.specification.listClone;

      if (listClone.length > 0) {
        for (let i = 0; i < listClone.length; i++) {
          let sortArr = document.getElementsByClassName("sort-item-" + i);

          if (sortArr.length > 0) {
            for (let j = 0; j < sortArr.length; j++) {
              let item = sortArr[j];

              item.draggable = true;
              item.style.cursor = "all-scroll";

              item.removeEventListener("dragstart", this.handleSortDragStart);
              item.addEventListener(
                "dragstart",
                this.handleSortDragStart,
                false,
              );

              item.removeEventListener("dragover", this.handleSortDragover);
              item.addEventListener("dragover", this.handleSortDragover, false);

              item.removeEventListener("drop", this.handleSortDrop);
              item.addEventListener("drop", this.handleSortDrop, false);
            }
          }
        }
      }
    },
    handleSortDragStart: function (ev) {
      ev.dataTransfer.setData("nindex", ev.target.dataset.nindex);
      ev.dataTransfer.setData("vindex", ev.target.dataset.vindex);
    },
    handleSortDragover: function (ev) {
      ev.preventDefault();
    },
    handleSortDrop: function (ev) {
      ev.preventDefault();

      let originalNindex = ev.dataTransfer.getData("nindex"),
        originalVindex = ev.dataTransfer.getData("vindex"),
        targetNindex = ev.target.getAttribute("data-nindex"),
        targetVindex = ev.target.getAttribute("data-vindex");

      if (originalNindex != targetNindex) {
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.formData.baseInfo.specification.listClone[
        targetNindex
      ].valueNameList.splice(originalVindex, 1);
      this.formData.baseInfo.specification.listClone[
        targetNindex
      ].valueNameList.splice(targetVindex, 0, originalObject[0]);
    },
    /**
     * [handleSpecificationDialogClose description] 规格排序弹窗 - 隐藏时触发的事件
     * @return   [description]
     */
    handleSpecificationDialogClose: function () {
      if (this.sorting) {
        let listClone = this.formData.baseInfo.specification.listClone;

        this.formData.baseInfo.specification.list = JSON.parse(
          JSON.stringify(listClone),
        );

        this.handlePackageSpecificationToParticular();
      }
    },
    /**
     * [handleSetBaseInfoPrice description] 根据规格明细表内价格变化，设置基础信息价格，取所有规格中价格最低的
     * @return   [description]
     */
    handleSetBaseInfoPrice: function () {
      this.updateLocalParticularData();

      let particularData = this.formData.baseInfo.specification.particularData,
        priceArr = [];

      for (let i = 0; i < particularData.length; i++) {
        if (particularData[i].price) {
          priceArr.push(particularData[i].price);
        }
      }

      if (priceArr.length == 0) {
        return false;
      }

      priceArr.sort(function (a, b) {
        return a - b;
      });

      this.formData.baseInfo.price = priceArr[0];
    },
    handlePriceChange: function () {},
    /**
     * [handleSetBaseInfoStock description]  根据规格明细表内价格变化，设置基础信息库存，取所有规格中的库存总和
     * @return   [description]
     */
    handleSetBaseInfoStock: function () {
      this.updateLocalParticularData();

      let particularData = this.formData.baseInfo.specification.particularData,
        stock = 0;

      for (let i = 0; i < particularData.length; i++) {
        if (particularData[i].stock) {
          stock += parseInt(particularData[i].stock);
        }
      }

      this.formData.baseInfo.stock = stock;
    },
    /**
     * [handleSetBaseInfoPresetSale description]  根据规格明细表内预设销量的变化，设置基础信息预设销量，取所有规格中的预设销量总和
     * @return   [description]
     */
    handleSetBaseInfoPresetSale: function () {
      this.updateLocalParticularData();

      let particularData = this.formData.baseInfo.specification.particularData,
        presetSale = 0;

      for (let i = 0; i < particularData.length; i++) {
        if (particularData[i].presetSale) {
          presetSale += parseInt(particularData[i].presetSale);
        }
      }

      this.formData.baseInfo.presetSale = presetSale;
    },
    /**
     * [handleDeliverFeeTypeChange description] 物流信息 - 快递发货 - 发货方式 改变
     * @return   [description]
     */
    handleDeliverFeeTypeChange: function (val) {
      // if(val == '0') {
      //     this.formData.deliverInfo.shippingTemplatesId = '';
      // } else if(val == '1') {
      //     this.formData.deliverInfo.deliverFee = '';
      // }
    },
    /**
     * [handleGetCommodityShippingTemplateList description] 获取运费模版列表
     * @return   [description]
     */
    handleGetCommodityShippingTemplateList: function (callback) {
      this.shippingTemplatesOptionsLoading = true;

      let params = {
        pageNo: 1,
        pageSize: 1000,
      };

      commodityShippingTemplateList(params).then((res) => {
        this.shippingTemplatesOptionsLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data.records || [];

          if (dataArray.length == 0) {
            this.shippingTemplatesOptions = [];
          } else {
            this.shippingTemplatesOptions = [];
            for (let i = 0; i < dataArray.length; i++) {
              let item = dataArray[i],
                name = "";

              if (item.type == 1) {
                name = "按件";
              } else if (item.type == 2) {
                name = "按重";
              }

              this.shippingTemplatesOptions.push({
                id: "" + item.id,
                type: item.type,
                name: name + ": " + item.name,
              });

              if (typeof callback === "function") {
                callback();
              }
            }
          }
        }
      });
    },
    /**
     * [handleDeliverWeightTypeChange description] 检测运费模版变化
     * @param    val [description]
     * @return       [description]
     */
    handleDeliverWeightTypeChange: function (val) {
      if (!val) {
        this.formData.deliverInfo.showWeight = false;
        return false;
      }

      let type = "";

      if (this.shippingTemplatesOptions.length == 0) {
        type = this.handleGetCommodityShippingTemplateList(
          this.handleGetShippingTemplateType(val),
        );
      } else {
        type = this.handleGetShippingTemplateType(val);
      }

      this.formData.deliverInfo.showWeight = type == 2 ? true : false;
    },
    /**
     * [handleGetShippingTemplateType description] 根据模版id获取模版类型值
     * @param    id [description]
     * @return      [description]
     */
    handleGetShippingTemplateType: function (id) {
      for (let i = 0; i < this.shippingTemplatesOptions.length; i++) {
        let item = this.shippingTemplatesOptions[i];

        if (item.id == id) {
          return item.type;
          break;
        }
      }
    },
    /**
     * [handleSameWeightChange description] 统一重量值变化
     * @return   [description]
     */
    handleSameWeightChange: function () {
      let weight = this.formData.deliverInfo.weight,
        particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].weight = weight;
      }

      this.formData.baseInfo.specification.particularData = particularData;
      this.updateLocalParticularData();
    },
    /**
     * [handleVideosBeforeUpload description] 视频上传之前
     * @param    file [description]
     * @return        [description]
     */
    handleVideosBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["mp4", "mov"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传MP4、MOV格式的图片");
        return false;
      }
    },
    handleVideosSuccess: function (response, file, fileList) {
      this.uploadVideoList = fileList;
    },
    handleVideosError: function (err, file, fileList) {
      this.$message.error("视频上传失败");
      this.uploadVideoList = fileList;
    },
    handleVideosExceed: function (files, fileList) {
      this.$message.error("视频最多上传" + this.videosLimit + "个");
    },
    handleVideosRemove: function (file, fileList) {
      this.uploadVideoList = [];
    },
    handleVideosPreview: function (file) {
      this.previewVideoDialogUrl = this.uploadVideoList[0].response.data.path;
      this.previewVideoDialogShow = true;
    },
    /**
     * [handlePicturesBeforeUpload description] 图片上传之前
     * @param    file [description]
     * @return        [description]
     */
    handlePicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传jpg、jpeg、png格式的图片");
        return false;
      }
    },
    /**
     * [handlePicturesSuccess description] 图片上传成功
     * @param    response [description]
     * @param    file     [description]
     * @param    fileList [description]
     * @return            [description]
     */
    handlePicturesSuccess: function (response, file, fileList) {
      this.uploadPicList = fileList;
    },
    /**
     * [handlePicturesError description] 图片上传失败
     * @param    err      [description]
     * @param    file     [description]
     * @param    fileList [description]
     * @return            [description]
     */
    handlePicturesError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
      this.uploadPicList = fileList;
    },
    /**
     * [handlePicturesExceed description] 图片数量超出限制
     * @param    files    [description]
     * @param    fileList [description]
     * @return            [description]
     */
    handlePicturesExceed: function (files, fileList) {
      this.$message.error("图片最多上传" + this.picsLimit + "张");
    },
    /**
     * [handlePicturesRemove description] 图片删除
     * @param    file     [description]
     * @param    fileList [description]
     * @return            [description]
     */
    handlePicturesRemove: function (file, fileList) {
      this.uploadPicList = fileList;
    },
    /**
     * [handlePictureCardPreview description] 图片预览
     * @param    file [description]
     * @return        [description]
     */
    handlePicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    /**
     * [handlePicListSort description] 图片列表排序
     * @return   [description]
     */
    handlePicListSort: function () {
      let picLI = document
        .getElementsByClassName("pics-box-goods")[0]
        .getElementsByClassName("el-upload-list")[0]
        .getElementsByTagName("li");

      for (let i = 0; i < picLI.length; i++) {
        let picLIItem = picLI[i];

        picLIItem.draggable = true;
        picLIItem.setAttribute("data-index", i);
        picLIItem.style.cursor = "all-scroll";

        picLIItem.removeEventListener("dragstart", this.handlePicLIDragStart);
        picLIItem.addEventListener(
          "dragstart",
          this.handlePicLIDragStart,
          false,
        );

        picLIItem.removeEventListener("dragover", this.handlePicLIDragover);
        picLIItem.addEventListener("dragover", this.handlePicLIDragover, false);

        picLIItem.removeEventListener("drop", this.handlePicLIDrop);
        picLIItem.addEventListener("drop", this.handlePicLIDrop, false);
      }
    },
    /**
     * [handlePicLIDragStart description] 拖动开始
     * @param    ev [description]
     * @return      [description]
     */
    handlePicLIDragStart: function (ev) {
      ev.dataTransfer.setData("index", ev.target.dataset.index);
    },
    /**
     * [handlePicLIDragover description] 必须存在，否则不会触发drop事件
     * @param    ev [description]
     * @return      [description]
     */
    handlePicLIDragover: function (ev) {
      ev.preventDefault();
    },
    /**
     * [handlePicLIDrop description] 拖动结束
     * @param    ev [description]
     * @return      [description]
     */
    handlePicLIDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData("index"),
        liNode = this.handleGetLINode(ev.target),
        targetIndex = liNode.getAttribute("data-index");

      if (originalIndex == targetIndex) {
        // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.uploadPicList.splice(originalIndex, 1);
      this.uploadPicList.splice(targetIndex, 0, originalObject[0]);

      this.formData.baseInfo.pics = [];
      for (let i = 0; i < this.uploadPicList.length; i++) {
        // this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.url);
        this.formData.baseInfo.pics.push(
          this.uploadPicList[i].response.data.path,
        );
      }
    },
    /**
     * [handleGetLINode description] 循环获取目标dom的标签名，直到找到li，返回该li对象
     * @param    ob [description]
     * @return      [description]
     */
    handleGetLINode: function (ob) {
      if (ob.tagName == "LI") {
        return ob;
      } else {
        return this.handleGetLINode(ob.parentNode);
      }
    },
    /**
     * [handleSpecificationPicturesBeforeUpload description] 图片上传之前
     * @param    file [description]
     * @return        [description]
     */
    handleSpecificationPicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传jpg、jpeg、png格式的图片");
        return false;
      }
    },
    handleSpecificationPicturesSuccess: function (response, file, fileList) {
      this.formData.baseInfo.specification.list[0].valueNameList[
        file.response.data.index
      ].picList = fileList;
    },
    handleSpecificationPicturesError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
      // this.uploadPicList = fileList;
    },
    handleSpecificationPicturesExceed: function (files, fileList) {
      this.$message.error("图片最多上传" + this.specificationPicsLimit + "张");
    },
    handleSpecificationPicturesRemove: function (file, fileList) {
      this.formData.baseInfo.specification.list[0].valueNameList[
        file.response.data.index
      ].picList = fileList;
    },
    handleSpecificationPicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    /**
     * [handleDetailPicturesBeforeUpload description] 图片上传之前
     * @param    file [description]
     * @return        [description]
     */
    handleDetailPicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传jpg、jpeg、png格式的图片");
        return false;
      }
    },
    handleDetailPicturesSuccess: function (response, file, fileList) {
      this.detailUploadPicList = fileList;
    },
    handleDetailPicturesError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
      // this.detailUploadPicList = fileList;
    },
    handleDetailPicturesRemove: function (file, fileList) {
      this.detailUploadPicList = fileList;
    },
    handleDetailPicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },

    /**
     * [handleDetailPicListSort description] 详情图片列表排序
     * @return   [description]
     */
    handleDetailPicListSort: function () {
      let picLI = document
        .getElementsByClassName("pics-box-detail")[0]
        .getElementsByClassName("el-upload-list")[0]
        .getElementsByTagName("li");

      for (let i = 0; i < picLI.length; i++) {
        let picLIItem = picLI[i];

        picLIItem.draggable = true;
        picLIItem.setAttribute("data-index", i);
        picLIItem.style.cursor = "all-scroll";

        picLIItem.removeEventListener(
          "dragstart",
          this.handleDetailPicLIDragStart,
        );
        picLIItem.addEventListener(
          "dragstart",
          this.handleDetailPicLIDragStart,
          false,
        );

        picLIItem.removeEventListener(
          "dragover",
          this.handleDetailPicLIDragover,
        );
        picLIItem.addEventListener(
          "dragover",
          this.handleDetailPicLIDragover,
          false,
        );

        picLIItem.removeEventListener("drop", this.handleDetailPicLIDrop);
        picLIItem.addEventListener("drop", this.handleDetailPicLIDrop, false);
      }
    },
    /**
     * [handleDetailPicLIDragStart description] 拖动开始
     * @param    ev [description]
     * @return      [description]
     */
    handleDetailPicLIDragStart: function (ev) {
      ev.dataTransfer.setData("index", ev.target.dataset.index);
    },
    /**
     * [handleDetailPicLIDragover description] 必须存在，否则不会触发drop事件
     * @param    ev [description]
     * @return      [description]
     */
    handleDetailPicLIDragover: function (ev) {
      ev.preventDefault();
    },
    /**
     * [handleDetailPicLIDrop description] 拖动结束
     * @param    ev [description]
     * @return      [description]
     */
    handleDetailPicLIDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData("index"),
        liNode = this.handleGetLINode(ev.target),
        targetIndex = liNode.getAttribute("data-index");

      if (originalIndex == targetIndex) {
        // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.detailUploadPicList.splice(originalIndex, 1);
      this.detailUploadPicList.splice(targetIndex, 0, originalObject[0]);

      this.detailPics = [];
      for (let i = 0; i < this.detailUploadPicList.length; i++) {
        // this.detailPics.push(this.detailUploadPicList[i].response.data.url);
        this.detailPics.push(this.detailUploadPicList[i].response.data.path);
      }
    },
    /**
     * [handleDetailGetLINode description] 循环获取目标dom的标签名，直到找到li，返回该li对象
     * @param    ob [description]
     * @return      [description]
     */
    handleDetailGetLINode: function (ob) {
      if (ob.tagName == "LI") {
        return ob;
      } else {
        return this.handleGetLINode(ob.parentNode);
      }
    },
    /**
     * [handleChangeStep description] 改变当前步骤
     * @param    step [description]
     * @return        [description]
     */
    handleChangeStep: function (step) {
      if (this.step == step) {
        return false;
      }

      if (step == 2) {
        if (this.handleValidateForm()) {
          this.step = step;
        }
      } else if (step == 1) {
        this.step = step;
      }
    },
    // 保存数据
    handleFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 详情
          if (this.detailPics.length == 0) {
            this.$message.error("请上传商品详情图");
            return false;
          }
          let formData = this.formData,
            baseInfo = formData.baseInfo;
          // 类目
          let categoryArr = [];
          for (let i = 0; i < baseInfo.categoryList.length; i++) {
            let item = baseInfo.categoryList[i];
            categoryArr.push({
              firstCategoryId: item.firstCategoryId,
              secondCategoryId: item.secondCategoryId,
              // categoryLabelId: item.categoryLabelId || null
              categoryLabelId: null,
            });
          }
          // 规格
          let specificationListArr = [];
          for (let i = 0; i < baseInfo.specification.list.length; i++) {
            let item = baseInfo.specification.list[i],
              valueArr = [];
            for (let j = 0; j < item.valueNameList.length; j++) {
              let valueItem = item.valueNameList[j],
                url = "";
              if (
                this.specificationPicsUploadVisible &&
                valueItem.picList &&
                valueItem.picList[0]
              ) {
                // url = valueItem.picList[0].response.data.url;
                url = valueItem.picList[0].response.data.path;
              }
              valueArr.push({
                name: valueItem.name,
                url: url,
              });
            }
            specificationListArr.push({
              name: item.name,
              valueNameList: valueArr,
            });
          }
          // 标签
          let tagsArr = [];
          if (baseInfo.tags.length > 0) {
            for (let i = 0; i < baseInfo.tags.length; i++) {
              let item = baseInfo.tags[i];
              if (item.label) {
                tagsArr.push(item.label);
              }
            }
          }
          this.submitLoading = true;
          let params = {
            pointType: baseInfo.pointType, // 商品类型
            sonType: baseInfo.sonType || null, // 权益类型
            day: baseInfo.day || null, // 券码有效天数
            id: this.id || null,
            regionId: baseInfo.regionId, // 产地
            rateId: baseInfo.rateId, // 税率
            includeTax: baseInfo.includeTax, //
            warehouseId: baseInfo.warehouseId, // 仓库
            name: baseInfo.name, // 商品名称
            code: baseInfo.code || new Date().getTime(), // 商品编码
            type: baseInfo.type, // 商品类型
            abroadType: baseInfo.abroadType, // 仓库类型
            syncSys: baseInfo.abroadType, // 仓库类型
            categoryInfo: JSON.stringify(categoryArr), // 类目
            sellingPoint: baseInfo.sellingPoint, // 卖点
            // mainVideo: this.uploadVideoList[0] ? this.uploadVideoList[0].response.data.url : '',
            mainVideo: this.uploadVideoList[0]
              ? this.uploadVideoList[0].response.data.path
              : "",
            listPics: baseInfo.pics.join(","), // 商品图
            picList: baseInfo.pics.join(","), // 商品图
            label: tagsArr.join(",") || null, // 标签
            specificationJsonStr: JSON.stringify(specificationListArr), // 商品规格
            specificationDetailJsonStr: JSON.stringify(
              baseInfo.specification.particularData,
            ), // 商品规格明细
            unit: this.unit,
            remark: baseInfo.remark,
            stock: baseInfo.stock, // 库存
            presetSale: baseInfo.presetSale || null, // 预设销量
            exchangeContent: baseInfo.exchangeContent,
            deliverInfo: JSON.stringify({
              // 物流信息
              deliverType: formData.deliverInfo.deliverType, // 配送方式
              // feeType: formData.deliverInfo.feeType, // 收费类型
              feeType: "0", // 收费类型
              // deliverFee: formData.deliverInfo.deliverFee, // 运费
              deliverFee: 0, // 运费
              weightType: formData.deliverInfo.weightType, // 物流重量
              shippingTemplatesId: formData.deliverInfo.shippingTemplatesId, // 运费模板
            }), // 物流信息设置
            detailPics: this.detailPics.join(","), // 详情图片
            pics: this.detailPics.join(","), // 详情图片
            pointsItemsWayList: baseInfo.pointsItemsWayList,
            // points: baseInfo.points,
            // pointsPrice: baseInfo.pointsPrice, // 积分兑换商品附加金额
          };
          if (this.unit === 0) {
            // 人民币
            params.price = baseInfo.price || 0;
            params.nickPrice = baseInfo.nickPrice || "";
          } else if (this.unit === 1) {
            // 韩币
            params.koreaPrice = baseInfo.price || "";
            params.koreaNickPrice = baseInfo.nickPrice || "";
          }
          // console.log(params);
          // return;
          if (baseInfo.type === 0) {
            pointsSaveOrUpdateProduct(params)
              .then((res) => {
                this.submitLoading = false;
                let { code, data, msg } = res;
                if (code == 0) {
                  this.$message({ message: "保存商品成功", type: "success" });
                  this.$router.push({ path: "/marketing/points/list" });
                } else {
                  this.$message.error(msg);
                }
              })
              .catch((error) => {
                this.submitLoading = false;
                this.$message.error("服务器异常");
              });
          } else {
            pointsSaveOrUpdateService(params)
              .then((res) => {
                this.submitLoading = false;
                let { code, data, msg } = res;
                if (code == 0) {
                  this.$message({ message: "保存项目成功", type: "success" });
                  this.$router.push({ path: "/marketing/points/list" });
                } else {
                  this.$message.error(msg);
                }
              })
              .catch((error) => {
                this.submitLoading = false;
                this.$message.error("服务器异常");
              });
          }
        } else {
          return false;
        }
      });
    },
    /**
     * [handleValidateForm description] 表单校验
     * @return   [description]
     */
    handleValidateForm: function () {
      let baseInfo = this.formData.baseInfo;

      // 商品名
      if (!baseInfo.name) {
        if (baseInfo.type === 0) {
          this.$message.error("请输入商品名称");
        } else if (baseInfo.type === 1) {
          this.$message.error("请输入项目名称");
        }
        return false;
      }

      // 权益类型校验
      if (baseInfo.pointType == 2) {
        if (!baseInfo.day) {
          this.$message.error("请填写券码有效天数");
          return false;
        }
        if (!baseInfo.sonType) {
          this.$message.error("请选择权益类型");
          return false;
        }
      }

      // 商品类目
      // let categoryList = baseInfo.categoryList;
      // if(categoryList.length == 0) {
      //     this.$message.error('请添加分类');
      //     return false;
      // }
      // for(let i = 0; i < categoryList.length; i++) {
      //     let item = categoryList[i];

      //     if(!item.firstCategoryId || !item.secondCategoryId) {
      //         this.$message.error('请选择分类');
      //         return false;
      //     }
      // }

      // 商品主图视频
      // if(baseInfo.pics.length == 0) {
      //     this.$message.error('请上传商品图');
      //     return false;
      // }

      // 商品图
      if (baseInfo.pics.length == 0) {
        this.$message.error("请上传商品图");
        return false;
      }

      // 标签
      // if(baseInfo.tags.length > 0) {
      //     for(let i = 0; i < baseInfo.tags.length; i++) {
      //         let item = baseInfo.tags[i];

      //         if(item.label && item.label.length < 2) {
      //             this.$message.error('标签名长度需2-8个中文字符');
      //             return false;
      //         }
      //     }
      // }

      if (baseInfo.type === 0) {
        // 规格
        let specification = baseInfo.specification.list;
        if (specification.length == 0) {
          this.$message.error("请添加商品规格");
          return false;
        } else {
          for (let i = 0; i < specification.length; i++) {
            let specificationItem = specification[i];

            if (!specificationItem.id) {
              this.$message.error("请选择商品规格名");
              return false;
            }

            if (specificationItem.valueNameList.length == 0) {
              this.$message.error("请添加商品规格值");
              return false;
            }

            for (let j = 0; j < specificationItem.valueNameList.length; j++) {
              let valueItem = specificationItem.valueNameList[j];

              if (!valueItem.name) {
                this.$message.error("请选择商品规格值");
                return false;
              }
            }
          }
        }

        // 规格明细
        let particularData = baseInfo.specification.particularData,
          skuCodeArr = [];
        for (let i = 0; i < particularData.length; i++) {
          let particularDataItem = particularData[i];

          if (particularDataItem.price === "") {
            this.$message.error("请输入规格明细的价格");
            return false;
          }

          if (particularDataItem.stock === "") {
            this.$message.error("请输入规格明细的库存");
            return false;
          }

          if (
            particularDataItem.skuCode === "" &&
            this.formData.baseInfo.pointType !== 2
          ) {
            this.$message.error("请输入规格明细的规格编码");
            return false;
          }

          if (skuCodeArr.indexOf(particularDataItem.skuCode) > -1) {
            this.$message.error(
              "规格编码[" + particularDataItem.skuCode + "]不能重复",
            );
            return false;
          } else {
            skuCodeArr.push(particularDataItem.skuCode);
          }
        }

        // 价格
        if (baseInfo.price === "") {
          this.$message.error("请输入价格");
          return false;
        }
      }

      if (baseInfo.type === 1) {
        // 价格
        if (baseInfo.price === "") {
          this.$message.error("请输入价格");
          return false;
        }
        // remark
        if (baseInfo.remark === "") {
          this.$message.error("请输入单位");
          return false;
        }
      }

      // 积分价格
      let hasEmpty = baseInfo.pointsItemsWayList.some((item) =>
        [item.points, item.price].some((val) => val === "" || val == null),
      );
      if (hasEmpty) {
        this.$message.error("积分/价格不能为空");
        return false;
      }

      // 库存
      if (baseInfo.stock === "") {
        this.$message.error("请输入库存");
        return false;
      }

      // 兑换说明
      if (baseInfo.exchangeContent === "") {
        this.$message.error("请输入兑换说明");
        return false;
      }

      // if(baseInfo.type == '0') {
      //     // 物流信息
      //     let deliverInfo = this.formData.deliverInfo;

      //     if(!deliverInfo.feeType) {
      //         this.$message.error('请选择快递运费');
      //         return false;
      //     }
      //     if(deliverInfo.feeType == '0' && deliverInfo.deliverFee === '') {
      //         this.$message.error('请填写统一邮费');
      //         return false;
      //     }
      //     if(deliverInfo.feeType == '1' && !deliverInfo.shippingTemplatesId) {
      //         this.$message.error('请选择运费模版');
      //         return false;
      //     }

      //     if(deliverInfo.feeType == '1' && deliverInfo.showWeight && !deliverInfo.weight && deliverInfo.weightType == '0') {
      //         this.$message.error('请输入统一重量');
      //         return false;
      //     }
      //     if(deliverInfo.feeType == '1' && deliverInfo.weightType == '1') {
      //         let particularData = baseInfo.specification.particularData;

      //         for(let i = 0; i < particularData.length; i++) {
      //             let particularDataItem = particularData[i];

      //             if(!particularDataItem.weight) {
      //                 this.$message.error('请完善物流重量');
      //                 return false;
      //             }
      //         }
      //     }
      // }

      return true;
    },
    switchType(val) {
      if (val === this.formData.baseInfo.pointType) {
        return;
      }
      this.$confirm("切换创建类型会清除目前页面的数据，确定切换吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 点击确定：切换选项并初始化页面内容
          this.initPageData(val);
        })
        .catch(() => {
          // 点击取消：由于使用了 :value 绑定，不需要做任何操作，选项会自动保持原样
        });
    },
    initPageData(pointType) {
      const initialData = this.$options.data.call(this);

      // 保持切换后的创建类型
      initialData.formData.baseInfo.pointType = pointType;

      // 仅重置表单和相关的状态，避免清空已通过API加载的下拉选项数据（如仓库、产地、税率等）
      this.formData = initialData.formData;
      this.step = initialData.step;
      this.unit = initialData.unit;
      this.uploadPicList = initialData.uploadPicList;
      this.detailPics = initialData.detailPics;
      this.detailUploadPicList = initialData.detailUploadPicList;
      this.uploadVideoList = initialData.uploadVideoList;
      this.specificationPicsUploadVisible =
        initialData.specificationPicsUploadVisible;
      this.localParticularData = initialData.localParticularData;

      this.$nextTick(() => {
        if (this.$refs.formData) {
          this.$refs.formData.clearValidate();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.steps-bar {
  border-radius: 48px;
  overflow: hidden;
  background: $colorTitleBg;

  .steps-item {
    background: transparent;
    font-size: $baseFS;
    line-height: 48px;
    text-align: center;

    &.active {
      background: $themeColor;
      color: $colorWhite;
      border-radius: 48px;
    }
  }
}

.type-wrap {
  font-size: 0;
  text-align: left;

  .type-item {
    position: relative;
    display: inline-block;
    margin-left: 80px;
    padding: 10px 20px;
    border: 1px solid #dddddd;
    border-radius: 2px;
    cursor: pointer;

    & + .type-item {
      margin-left: 10px;
    }

    .label {
      font-size: 12px;
      line-height: 17px;
      color: #222;
    }

    .tips {
      margin-top: 4px;
      font-size: 12px;
      line-height: 17px;
      color: rgba(#222, 0.5);
    }

    &.active {
      border-color: $themeColor;

      .label {
        color: $themeColor;
      }

      &::before {
        content: "";
        @include position(absolute, 3, 0, 0, none, none);
        width: 16px;
        height: 16px;
        @include backgroundImage(
          "../../../assets/icon_16_2@2x.png",
          no-repeat,
          right,
          center,
          auto,
          16px
        );
      }
    }
  }
}

.radio-block {
  .tips {
    margin-left: 24px;
  }
}

.checkbox-block,
.switch-block {
  & + .checkbox-block,
  & + .switch-block {
    margin-left: 20px;
  }
}

.grey-inline-block {
  display: inline-block;
  background: $colorPageBg;
}

.paticular-table {
  background-color: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {
  }

  ::v-deep .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        background-color: transparent;

        td {
          padding: 5px 0;
          border-bottom-color: #ebeef5;
          /*border-bottom-color: transparent;*/
        }
      }
    }
  }
}

.pics-box {
  ::v-deep .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;
      transition: none;

      .el-upload-list__item-thumbnail {
        @include position(absolute, none, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
      }

      .el-progress {
        width: 80px;
        height: 80px;

        .el-progress-circle {
          width: 80px !important;
          height: 80px !important;
        }
      }

      .el-icon-close-tip {
        display: none;
      }

      .el-upload-list__item-actions {
        cursor: move;
      }
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;

      .el-icon-plus {
        font-size: $baseFS;
      }
    }
  }

  .video-box {
    .video-item {
      position: relative;
      width: 100px;
      height: 100px;

      .video {
        width: 98px;
        height: 98px;
        border: 1px solid #c0ccda;
      }

      .mask {
        @include position(absolute, 1, 0, 0, 0, 0);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background: rgba(#000, 0.5);
        opacity: 0;
        transition: opacity 0.3s;

        i {
          font-size: 20px;
          color: #fff;
          cursor: pointer;

          & + i {
            margin-left: 15px;
          }
        }
      }

      &:hover {
        .mask {
          opacity: 1;
          transition: opacity 0.3s;
        }
      }
    }
  }
}

.particular-toolbar {
  padding: 8px 10px;
}

.sort-item {
  display: inline-block;
  padding: 0 12px;
  margin-right: 10px;
  line-height: 28px;
  white-space: nowrap;
  background-color: #eee;
  font-size: $smallFS;
  color: $textColor;
  border-radius: 2px;

  &:hover,
  &:focus {
    background-color: rgba(#5bcfe6, 0.2);
  }
}

.delete-block-category {
  margin-left: 70px;
  margin-bottom: 18px;

  .el-form-item {
    margin-left: -70px;
    margin-bottom: 0;

    & + .el-form-item {
      margin-top: 8px;
    }
  }
}

.specification-value-item {
  float: left;

  .specification-pics-box {
    position: relative;
    margin-bottom: 10px;

    .pics-box {
      width: 100px;
      height: 100px;
      overflow: hidden;
    }
  }
}

.select-loading {
  @include position(absolute, 10, 3px, 2px, 3px, 0);
  display: block;
  background: transparent;
  width: 100%;
  border: none;
  pointer-events: inherit;

  /*&::before{
            display: none;
        }*/

  &::after {
    border: none;
  }

  ::v-deep .el-icon-loading {
    color: $themeColor;
  }
}
</style>
